/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { gammaDependencies } from './dependenciesGamma.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createFactorial } from '../../factoriesAny.js';
export var factorialDependencies = {
  gammaDependencies: gammaDependencies,
  typedDependencies: typedDependencies,
  createFactorial: createFactorial
};